import React from "react";

import type { Language } from "@admin/domain/languages/helpers";
import type { ProductTextModel } from "@admin/domain/products/models/ProductTextModel";
import Input from "@admin/components/Input";
import TextArea from "@admin/components/TextArea";
import JoditEditor from "@admin/components/JoditEditor";

type TextsProps = {
    language: Language;
    texts: ProductTextModel[];
};

export default function Texts(props: TextsProps) {
    const texts = new Map(props.texts.map((value) => [value.language, value]));

    return (
        <>
            <Input
                label="Название"
                name={`product_attributes[text][${props.language}][title]`}
                defaultValue={texts.get(props.language)?.title}
            />

            <JoditEditor
                label="Описание"
                name={`product_attributes[text][${props.language}][description]`}
                initHtml={texts.get(props.language)?.description}
            />

            <JoditEditor
                label="Краткое описание"
                name={`product_attributes[text][${props.language}][excerpt]`}
                initHtml={texts.get(props.language)?.excerpt}
            />

            <JoditEditor
                label="Использование"
                name={`product_attributes[text][${props.language}][usage]`}
                initHtml={texts.get(props.language)?.usage}
            />

            <JoditEditor
                label="Текст письма после Квиза"
                name={`product_attributes[text][${props.language}][quizEmailText]`}
                initHtml={texts.get(props.language)?.quizEmailText}
            />

            <JoditEditor
                label="Текст письма/уведомления после покупки"
                name={`product_attributes[text][${props.language}][notification]`}
                initHtml={texts.get(props.language)?.notification}
            />

            <TextArea
                label="Ключевые слова для поиска"
                name={`product_attributes[text][${props.language}][keywords]`}
                defaultValue={texts.get(props.language)?.keywords}
            />
        </>
    );
}
